import { render, staticRenderFns } from "./ActionFormRelatedReacts.vue?vue&type=template&id=b54b8aaa&scoped=true&"
import script from "./ActionFormRelatedReacts.vue?vue&type=script&lang=js&"
export * from "./ActionFormRelatedReacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b8aaa",
  null
  
)

export default component.exports